// Country currency codes and symbols
export const countryCurrencies = [
  { country: 'AF', code: 'AFN', symbol: '؋', name: 'Afghan Afghani' },
  { country: 'AL', code: 'ALL', symbol: 'L', name: 'Albanian Lek' },
  { country: 'DZ', code: 'DZD', symbol: 'د.ج', name: 'Algerian Dinar' },
  { country: 'AO', code: 'AOA', symbol: 'Kz', name: 'Angolan Kwanza' },
  { country: 'AR', code: 'ARS', symbol: '$', name: 'Argentine Peso' },
  { country: 'AM', code: 'AMD', symbol: '֏', name: 'Armenian Dram' },
  { country: 'AU', code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { country: 'AT', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'AZ', code: 'AZN', symbol: '₼', name: 'Azerbaijani Manat' },
  { country: 'BH', code: 'BHD', symbol: '.د.ب', name: 'Bahraini Dinar' },
  { country: 'BD', code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka' },
  { country: 'BY', code: 'BYN', symbol: 'Br', name: 'Belarusian Ruble' },
  { country: 'BE', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'BZ', code: 'BZD', symbol: 'BZ$', name: 'Belize Dollar' },
  { country: 'BJ', code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  { country: 'BT', code: 'BTN', symbol: 'Nu.', name: 'Bhutanese Ngultrum' },
  { country: 'BO', code: 'BOB', symbol: 'Bs.', name: 'Bolivian Boliviano' },
  { country: 'BA', code: 'BAM', symbol: 'KM', name: 'Bosnia-Herzegovina Convertible Mark' },
  { country: 'BW', code: 'BWP', symbol: 'P', name: 'Botswanan Pula' },
  { country: 'BR', code: 'BRL', symbol: 'R$', name: 'Brazilian Real' },
  { country: 'BN', code: 'BND', symbol: 'B$', name: 'Brunei Dollar' },
  { country: 'BG', code: 'BGN', symbol: 'лв', name: 'Bulgarian Lev' },
  { country: 'BF', code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  { country: 'BI', code: 'BIF', symbol: 'FBu', name: 'Burundian Franc' },
  { country: 'KH', code: 'KHR', symbol: '៛', name: 'Cambodian Riel' },
  { country: 'CM', code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  { country: 'CA', code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { country: 'CV', code: 'CVE', symbol: '$', name: 'Cape Verdean Escudo' },
  { country: 'CF', code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  { country: 'TD', code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  { country: 'CL', code: 'CLP', symbol: '$', name: 'Chilean Peso' },
  { country: 'CN', code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { country: 'CO', code: 'COP', symbol: '$', name: 'Colombian Peso' },
  { country: 'KM', code: 'KMF', symbol: 'CF', name: 'Comorian Franc' },
  { country: 'CG', code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  { country: 'CD', code: 'CDF', symbol: 'FC', name: 'Congolese Franc' },
  { country: 'CR', code: 'CRC', symbol: '₡', name: 'Costa Rican Colón' },
  { country: 'CI', code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  { country: 'HR', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'CU', code: 'CUP', symbol: '$', name: 'Cuban Peso' },
  { country: 'CY', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'CZ', code: 'CZK', symbol: 'Kč', name: 'Czech Koruna' },
  { country: 'DK', code: 'DKK', symbol: 'kr', name: 'Danish Krone' },
  { country: 'DJ', code: 'DJF', symbol: 'Fdj', name: 'Djiboutian Franc' },
  { country: 'DO', code: 'DOP', symbol: 'RD$', name: 'Dominican Peso' },
  { country: 'EC', code: 'USD', symbol: '$', name: 'US Dollar' },
  { country: 'EG', code: 'EGP', symbol: '£', name: 'Egyptian Pound' },
  { country: 'SV', code: 'USD', symbol: '$', name: 'US Dollar' },
  { country: 'GQ', code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  { country: 'ER', code: 'ERN', symbol: 'Nfk', name: 'Eritrean Nakfa' },
  { country: 'EE', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'ET', code: 'ETB', symbol: 'Br', name: 'Ethiopian Birr' },
  { country: 'FJ', code: 'FJD', symbol: 'FJ$', name: 'Fijian Dollar' },
  { country: 'FI', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'FR', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'GA', code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  { country: 'GM', code: 'GMD', symbol: 'D', name: 'Gambian Dalasi' },
  { country: 'GE', code: 'GEL', symbol: '₾', name: 'Georgian Lari' },
  { country: 'DE', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'GH', code: 'GHS', symbol: '₵', name: 'Ghanaian Cedi' },
  { country: 'GR', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'GT', code: 'GTQ', symbol: 'Q', name: 'Guatemalan Quetzal' },
  { country: 'GN', code: 'GNF', symbol: 'FG', name: 'Guinean Franc' },
  { country: 'GW', code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  { country: 'GY', code: 'GYD', symbol: 'G$', name: 'Guyanese Dollar' },
  { country: 'HT', code: 'HTG', symbol: 'G', name: 'Haitian Gourde' },
  { country: 'HN', code: 'HNL', symbol: 'L', name: 'Honduran Lempira' },
  { country: 'HK', code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar' },
  { country: 'HU', code: 'HUF', symbol: 'Ft', name: 'Hungarian Forint' },
  { country: 'IS', code: 'ISK', symbol: 'kr', name: 'Icelandic Króna' },
  { country: 'IN', code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { country: 'ID', code: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah' },
  { country: 'IR', code: 'IRR', symbol: '﷼', name: 'Iranian Rial' },
  { country: 'IQ', code: 'IQD', symbol: 'ع.د', name: 'Iraqi Dinar' },
  { country: 'IE', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'IL', code: 'ILS', symbol: '₪', name: 'Israeli New Shekel' },
  { country: 'IT', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'JM', code: 'JMD', symbol: 'J$', name: 'Jamaican Dollar' },
  { country: 'JP', code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { country: 'JO', code: 'JOD', symbol: 'د.ا', name: 'Jordanian Dinar' },
  { country: 'KZ', code: 'KZT', symbol: '₸', name: 'Kazakhstani Tenge' },
  { country: 'KE', code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling' },
  { country: 'KP', code: 'KPW', symbol: '₩', name: 'North Korean Won' },
  { country: 'KR', code: 'KRW', symbol: '₩', name: 'South Korean Won' },
  { country: 'KW', code: 'KWD', symbol: 'د.ك', name: 'Kuwaiti Dinar' },
  { country: 'KG', code: 'KGS', symbol: 'с', name: 'Kyrgyzstani Som' },
  { country: 'LA', code: 'LAK', symbol: '₭', name: 'Laotian Kip' },
  { country: 'LV', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'LB', code: 'LBP', symbol: 'ل.ل', name: 'Lebanese Pound' },
  { country: 'LS', code: 'LSL', symbol: 'L', name: 'Lesotho Loti' },
  { country: 'LR', code: 'LRD', symbol: 'L$', name: 'Liberian Dollar' },
  { country: 'LY', code: 'LYD', symbol: 'ل.د', name: 'Libyan Dinar' },
  { country: 'LT', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'LU', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'MG', code: 'MGA', symbol: 'Ar', name: 'Malagasy Ariary' },
  { country: 'MW', code: 'MWK', symbol: 'MK', name: 'Malawian Kwacha' },
  { country: 'MY', code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit' },
  { country: 'MV', code: 'MVR', symbol: 'Rf', name: 'Maldivian Rufiyaa' },
  { country: 'ML', code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  { country: 'MT', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'MR', code: 'MRU', symbol: 'UM', name: 'Mauritanian Ouguiya' },
  { country: 'MU', code: 'MUR', symbol: '₨', name: 'Mauritian Rupee' },
  { country: 'MX', code: 'MXN', symbol: '$', name: 'Mexican Peso' },
  { country: 'MD', code: 'MDL', symbol: 'L', name: 'Moldovan Leu' },
  { country: 'MN', code: 'MNT', symbol: '₮', name: 'Mongolian Tögrög' },
  { country: 'ME', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'MA', code: 'MAD', symbol: 'د.م.', name: 'Moroccan Dirham' },
  { country: 'MZ', code: 'MZN', symbol: 'MT', name: 'Mozambican Metical' },
  { country: 'MM', code: 'MMK', symbol: 'K', name: 'Myanmar Kyat' },
  { country: 'NA', code: 'NAD', symbol: 'N$', name: 'Namibian Dollar' },
  { country: 'NP', code: 'NPR', symbol: '₨', name: 'Nepalese Rupee' },
  { country: 'NL', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'NZ', code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar' },
  { country: 'NI', code: 'NIO', symbol: 'C$', name: 'Nicaraguan Córdoba' },
  { country: 'NE', code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  { country: 'NG', code: 'NGN', symbol: '₦', name: 'Nigerian Naira' },
  { country: 'NO', code: 'NOK', symbol: 'kr', name: 'Norwegian Krone' },
  { country: 'OM', code: 'OMR', symbol: 'ر.ع.', name: 'Omani Rial' },
  { country: 'PK', code: 'PKR', symbol: '₨', name: 'Pakistani Rupee' },
  { country: 'PS', code: 'ILS', symbol: '₪', name: 'Israeli New Shekel' },
  { country: 'PA', code: 'PAB', symbol: 'B/.', name: 'Panamanian Balboa' },
  { country: 'PG', code: 'PGK', symbol: 'K', name: 'Papua New Guinean Kina' },
  { country: 'PY', code: 'PYG', symbol: '₲', name: 'Paraguayan Guaraní' },
  { country: 'PE', code: 'PEN', symbol: 'S/', name: 'Peruvian Sol' },
  { country: 'PH', code: 'PHP', symbol: '₱', name: 'Philippine Peso' },
  { country: 'PL', code: 'PLN', symbol: 'zł', name: 'Polish Złoty' },
  { country: 'PT', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'QA', code: 'QAR', symbol: 'ر.ق', name: 'Qatari Riyal' },
  { country: 'RO', code: 'RON', symbol: 'lei', name: 'Romanian Leu' },
  { country: 'RU', code: 'RUB', symbol: '₽', name: 'Russian Ruble' },
  { country: 'RW', code: 'RWF', symbol: 'FRw', name: 'Rwandan Franc' },
  { country: 'SA', code: 'SAR', symbol: 'ر.س', name: 'Saudi Riyal' },
  { country: 'SN', code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  { country: 'RS', code: 'RSD', symbol: 'дин.', name: 'Serbian Dinar' },
  { country: 'SL', code: 'SLL', symbol: 'Le', name: 'Sierra Leonean Leone' },
  { country: 'SG', code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
  { country: 'SK', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'SI', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'SO', code: 'SOS', symbol: 'Sh.So.', name: 'Somali Shilling' },
  { country: 'ZA', code: 'ZAR', symbol: 'R', name: 'South African Rand' },
  { country: 'ES', code: 'EUR', symbol: '€', name: 'Euro' },
  { country: 'LK', code: 'LKR', symbol: 'Rs', name: 'Sri Lankan Rupee' },
  { country: 'SD', code: 'SDG', symbol: 'ج.س.', name: 'Sudanese Pound' },
  { country: 'SR', code: 'SRD', symbol: '$', name: 'Surinamese Dollar' },
  { country: 'SE', code: 'SEK', symbol: 'kr', name: 'Swedish Krona' },
  { country: 'CH', code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  { country: 'SY', code: 'SYP', symbol: '£', name: 'Syrian Pound' },
  { country: 'TW', code: 'TWD', symbol: 'NT$', name: 'New Taiwan Dollar' },
  { country: 'TJ', code: 'TJS', symbol: 'ЅM', name: 'Tajikistani Somoni' },
  { country: 'TZ', code: 'TZS', symbol: 'TSh', name: 'Tanzanian Shilling' },
  { country: 'TH', code: 'THB', symbol: '฿', name: 'Thai Baht' },
  { country: 'TL', code: 'USD', symbol: '$', name: 'US Dollar' },
  { country: 'TG', code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  { country: 'TO', code: 'TOP', symbol: 'T$', name: 'Tongan Paʻanga' },
  { country: 'TN', code: 'TND', symbol: 'د.ت', name: 'Tunisian Dinar' },
  { country: 'TR', code: 'TRY', symbol: '₺', name: 'Turkish Lira' },
  { country: 'TM', code: 'TMT', symbol: 'T', name: 'Turkmenistan Manat' },
  { country: 'UG', code: 'UGX', symbol: 'USh', name: 'Ugandan Shilling' },
  { country: 'UA', code: 'UAH', symbol: '₴', name: 'Ukrainian Hryvnia' },
  { country: 'AE', code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  { country: 'GB', code: 'GBP', symbol: '£', name: 'British Pound' },
  { country: 'US', code: 'USD', symbol: '$', name: 'US Dollar' },
  { country: 'UY', code: 'UYU', symbol: '$U', name: 'Uruguayan Peso' },
  { country: 'UZ', code: 'UZS', symbol: 'som', name: 'Uzbekistani Som' },
  { country: 'VE', code: 'VES', symbol: 'Bs.S', name: 'Venezuelan Bolívar' },
  { country: 'VN', code: 'VND', symbol: '₫', name: 'Vietnamese Dong' },
  { country: 'YE', code: 'YER', symbol: 'ر.ي', name: 'Yemeni Rial' },
  { country: 'ZM', code: 'ZMW', symbol: 'ZK', name: 'Zambian Kwacha' },
  { country: 'ZW', code: 'ZWL', symbol: '$', name: 'Zimbabwean Dollar' }
];

// Utility functions
export const getCurrencySymbol = (countryCode) => {
  const currency = countryCurrencies.find(c => c.country === countryCode);
  return currency ? currency.symbol : '$';
};

export const getCurrencyName = (countryCode) => {
  const currency = countryCurrencies.find(c => c.country === countryCode);
  return currency ? currency.name : 'US Dollar';
};

export const getCurrencyCode = (countryCode) => {
  const currency = countryCurrencies.find(c => c.country === countryCode);
  return currency ? currency.code : 'USD';
};

export const getCurrencyByCountry = (countryCode) => {
  return countryCurrencies.find(c => c.country === countryCode) || 
         { country: countryCode, code: 'USD', symbol: '$', name: 'US Dollar' };
}; 